import { UserSign, setLocalSign } from "@/utils/sign"
import { createContext } from "react"

export const signDefaultValue = {
  signs: [] as UserSign[],
  setLocalSign,
}

export const SignContext = createContext(signDefaultValue)